import React from "react";
const IpFinder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 21}
    height={props?.height || 20}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      d="M7.83331 9.15967H12.8203C12.7422 7.26576 12.4035 5.59577 11.9169 4.37595C11.6373 3.67506 11.3254 3.16419 11.0218 2.84226C10.7199 2.5221 10.4847 2.44531 10.3268 2.44531C10.1689 2.44531 9.93374 2.5221 9.63182 2.84226C9.32824 3.16419 9.01632 3.67506 8.73674 4.37595C8.2502 5.59577 7.91145 7.26576 7.83331 9.15967Z"
      fill="#6880CF"
    />
    <path
      d="M12.8203 10.8398C12.7422 12.7338 12.4035 14.4038 11.9169 15.6236C11.6373 16.3244 11.3254 16.8353 11.0218 17.1573C10.7199 17.4774 10.4847 17.5542 10.3268 17.5542C10.1689 17.5542 9.93374 17.4774 9.63182 17.1573C9.32824 16.8353 9.01632 16.3244 8.73674 15.6236C8.2502 14.4038 7.91145 12.7338 7.83331 10.8398H12.8203Z"
      fill="#6880CF"
    />
    <path
      d="M14.5027 10.8398H19.2924C18.903 15.0723 15.5989 18.4578 11.4114 18.9589C11.7224 18.7953 12.0012 18.5693 12.2451 18.3106C12.7425 17.7832 13.1519 17.0649 13.4782 16.247C14.0554 14.7998 14.4238 12.9106 14.5027 10.8398Z"
      fill="#6880CF"
    />
    <path
      d="M19.2924 9.15814H14.5027C14.4238 7.08744 14.0554 5.19813 13.4782 3.75101C13.1519 2.93309 12.7425 2.21485 12.2451 1.68737C12.0012 1.42872 11.7224 1.20264 11.4114 1.03906C15.5989 1.54023 18.903 4.92575 19.2924 9.15814Z"
      fill="#6880CF"
    />
    <path
      d="M6.16208 9.15814H1.37238C1.76168 4.92575 5.06588 1.54023 9.25329 1.03906C8.94238 1.20264 8.66351 1.42872 8.4196 1.68737C7.92218 2.21485 7.51277 2.93309 7.18653 3.75101C6.60933 5.19813 6.24092 7.08744 6.16208 9.15814Z"
      fill="#6880CF"
    />
    <path
      d="M6.16208 10.8398H1.37238C1.76168 15.0723 5.06588 18.4578 9.25329 18.9589C8.94238 18.7953 8.66351 18.5693 8.4196 18.3106C7.92218 17.7832 7.51277 17.0649 7.18653 16.247C6.60933 14.7998 6.24092 12.9106 6.16208 10.8398Z"
      fill="#6880CF"
    />
  </svg>
);
export default IpFinder;
